import React from 'react';
import { Input, Section } from '../Shared';
import { StyledDropdown as CheggUiDropdown } from '../Shared/styled';
import { PubMainTypeEnum, PubSuffixTypeEnum, SourceType } from '../../types';
import { citingOptions } from '../../forms/digital-file/constants';
export var SECTION_ID = 'digital-file-what-im-citing';
export var SECTION_TEST_ID = "".concat(SECTION_ID, "-test");
export var CITING_FIELD_TEST_ID = 'citing-field-test-id';
export var TITLE_OF_FILE_FIELD_TEST_ID = 'title-of-file-test-id';
export var TYPE_OF_FILE_FIELD_TEST_ID = 'type-of-file-test-id';
export var DigitalFileCitingSection = function DigitalFileCitingSection(_ref) {
  var onSourceChange = _ref.onSourceChange;
  var handleCitationOptionChange = function handleCitationOptionChange(_ref2) {
    var value = _ref2.value;
    if (onSourceChange && value !== SourceType.DIGITAL_FILE) {
      onSourceChange(value, {
        main: PubMainTypeEnum.PUB_ONLINE,
        suffix: PubSuffixTypeEnum.PUB_NONE
      });
    }
  };
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: "What I'm citing",
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(CheggUiDropdown, {
    inputId: "source",
    value: citingOptions[0].value,
    options: citingOptions,
    labelText: 'Citing',
    "data-test": CITING_FIELD_TEST_ID,
    helperText: "Change the source type if necessary.",
    onSelectValue: function onSelectValue(selectedOption) {
      return handleCitationOptionChange({
        value: selectedOption
      });
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "data-test": TITLE_OF_FILE_FIELD_TEST_ID,
    name: "digital.title",
    labelText: "Title of file"
  }), /*#__PURE__*/React.createElement(Input, {
    "data-test": TYPE_OF_FILE_FIELD_TEST_ID,
    name: "digital.desc",
    labelText: "Type of file",
    helperText: "Ex: PDF, PPT, etc."
  }));
};